type DataLayerEvent = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

const ensureDataLayer = (): DataLayerEvent[] | null => {
  if (typeof window === 'undefined') return null;
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
};

export const pushToDataLayer = (eventData: DataLayerEvent): void => {
  const dataLayer = ensureDataLayer();
  if (!dataLayer) return;
  dataLayer.push(eventData);
};

export const trackProductSelect = (product: {
  id?: string | number;
  name?: string;
  category_id?: string | number;
  price?: number;
  variant?: string;
}): void => {
  pushToDataLayer({
    event: 'select_item',
    ecommerce: {
      items: [
        {
          item_id: product.id ?? '',
          item_name: product.name ?? '',
          item_category: product.category_id ?? '',
          price: product.price ?? 0,
          item_variant: product.variant ?? '',
        },
      ],
    },
  });
};

export const trackAddToCart = (item: {
  id?: string | number;
  name?: string;
  category_id?: string | number;
  price?: number;
  quantity?: number;
  variant?: string;
}): void => {
  pushToDataLayer({
    event: 'add_to_cart',
    ecommerce: {
      currency: '',
      value: (item.price ?? 0) * (item.quantity ?? 1),
      items: [
        {
          item_id: item.id ?? '',
          item_name: item.name ?? '',
          item_category: item.category_id ?? '',
          price: item.price ?? 0,
          quantity: item.quantity ?? 1,
          item_variant: item.variant ?? '',
        },
      ],
    },
  });
};
